import getUserIp from './getUserIp'
import saveParams from './saveParams'
import uploadLogoCliente from './uploadLogoCliente'
import uploadFooterPortal from './uploadFooterPortal'

export const getUserIpPromise = getUserIp
export const saveParamsPromise = saveParams
export const uploadLogoClientePromise = uploadLogoCliente
export const uploadFooterPortalPromise = uploadFooterPortal
